module.exports = __webpack_public_path__ + "static/img/7.77d8998.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/culturalCourses/7.png
// module id = SoQS
// module chunks = 0